import { CommandStepState } from "./commandStepState.model";

export class CommandStep {
  Id: string;
  Timestamp: Date;
  State: CommandStepState;
  Step: string;

  constructor(attempt: {
    id?: string;
    timestamp?: Date;
    state?: CommandStepState;
    step?: string;
  }) {
    this.Id = attempt.id;
    this.Timestamp = attempt.timestamp;
    this.State = attempt.state;
    this.Step = attempt.step;
  }
}
